import { must } from './dom';

const VISIBLE_MS = 2600;

/** How often deferred ambient news re-checks for a free slot. */
const RETRY_MS = 300;

let timer: ReturnType<typeof setTimeout> | null = null;

/** Brief, non-blocking message at the bottom of the screen. */
export function toast(message: string): void {
  const node = must('toast');
  node.textContent = message;
  node.classList.add('show');
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => node.classList.remove('show'), VISIBLE_MS);
}

/**
 * A toast that yields. Ambient chrome news — the offline-ready notice — must
 * never replace a nudge the player just provoked, so it waits for the toast
 * in view to clear before taking the slot.
 */
export function quietToast(message: string): void {
  if (must('toast').classList.contains('show')) {
    setTimeout(() => quietToast(message), RETRY_MS);
    return;
  }
  toast(message);
}
